import { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import UserMenu from './UserMenu';
import { useAuth } from '../contexts/AuthContext';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { user, logout } = useAuth();
  const location = useLocation();

  const navItems = [
    { name: 'About', href: '/about' },
    { name: 'Services', href: '/services' },
    { name: 'Catalog', href: '/catalog' },
    { name: 'Examples', href: '/industry-examples' },
    { name: 'Contact', href: '/contact' },
  ];

  return (
    <header className="sticky top-0 z-50 transition-all duration-300 bg-header text-text-primary shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 backdrop-blur-md ">
        <div className="flex items-center justify-between h-16 ">
          {/* Logo */}
          <div className="flex-shrink-0">
            <NavLink to="/">
              <img 
                src="/LogoWide.webp"
                alt="Contextral Logo" 
                className="h-8 w-auto"
                width={224}
                height={32}
              />
            </NavLink>
            
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8">
            {navItems.map((item) => (
              <NavLink
                key={item.name}
                to={item.href}
                className={({ isActive }) => 
                  `text-sm font-medium transition-colors duration-200 hover:text-primary ${
                    isActive && 'text-primary'
                  }`}
              >
                {item.name}
              </NavLink>
            ))}
          </nav>

          {/* CTA Button and User Menu */}
          <div className="hidden md:flex items-center space-x-4">
            {!user && (
              <Link
                to="/book"
                className="bg-primary text-text-inverse px-6 py-2 rounded-full text-sm font-medium hover:bg-primaryHover transition-all duration-200 transform hover:scale-105"
              >
                Book Assessment
              </Link>
            )}
            
            <UserMenu />
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className={"p-2 rounded-md transition-colors text-primary hover:bg-surfaceSoft"}
            >
              {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </div>
      {/* Mobile Navigation */}
      {isMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-200 shadow-lg">
          <div className="px-2 pt-2 pb-3 space-y-1">
            {navItems.map((item) => (
              <NavLink
                key={item.name}
                to={item.href}
                className={({ isActive }) => 
                  `block px-3 py-2 text-base font-medium rounded-md transition-colors ${
                    isActive ? 'text-primary bg-surfaceSoft' : 'text-text-secondary hover:text-primary hover:bg-surfaceSoft'
                  }`}
                onClick={() => setIsMenuOpen(false)}
              >
                {item.name}
              </NavLink>
            ))}
            
            {!user && (
              <>
                <div className="mt-4 border-t border-gray-200 pt-4">
                  <Link
                    to="/book"
                    className="block w-full px-3 py-2 text-left text-base font-medium text-primary hover:bg-surfaceSoft rounded-md"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    Book a Free Assessment
                  </Link>
                  <NavLink
                    to="/auth"
                    state={{ from: location }}
                    className="block px-3 py-2 text-base font-medium text-text-secondary hover:text-primary hover:bg-surfaceSoft rounded-md"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    Sign In
                  </NavLink>
                </div>
              </>
            )}

            {user && (
              <div className="mt-4 border-t border-gray-200 pt-4 space-y-1">
                <NavLink
                  to="/account"
                  className={({ isActive }) => 
                    `block px-3 py-2 text-base font-medium rounded-md transition-colors ${
                      isActive && 'text-primary'
                    }`}
                  onClick={() => setIsMenuOpen(false)}
                >
                  Account
                </NavLink>
                <button
                  onClick={() => {
                    logout();
                    setIsMenuOpen(false);
                  }}
                  className="block w-full text-left px-3 py-2 text-base font-medium text-red-600 hover:bg-gray-50 rounded-md"
                >
                  Sign Out
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
